import React from 'react';
import Postnav from '../../components/Postnav/Postnav';
import Footer from '../../components/Footer/Footer'
import Cart from '../../components/Cart/Cart';


function Cartpage() {

  return (
    <div className="cart-route-page">
      <div className="outheader">
        <div className="background">
          <div className="background-center-color">
            <div className="postnav-container">
              <Postnav />
            </div>
            <Cart />
          </div>
        </div>
      </div>
      <Footer />
    </div>
    
  );
}

export default Cartpage;
